import { render } from "./ConfigurationProvisions.vue?vue&type=template&id=4f715fae&scoped=true"
import script from "./ConfigurationProvisions.vue?vue&type=script&lang=js"
export * from "./ConfigurationProvisions.vue?vue&type=script&lang=js"

import "./ConfigurationProvisions.vue?vue&type=style&index=0&id=4f715fae&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f715fae"]])

export default __exports__